/**
 * Global application constants
 */

export const PARTNER_SUCCESS_EMAIL = "partner-success@poweredbylight.com";
export const DOCS_QUICKSTART_URL = "https://docs.light.dev/quickstart";
